module.exports = __webpack_public_path__ + "9c96672bf02cf409ca212da432564ea1.svg";